import * as React from 'react'
import Box from '@mui/joy/Box'
import Radio, { radioClasses } from '@mui/joy/Radio'
import RadioGroup from '@mui/joy/RadioGroup'
import FormatAlignCenter from '@mui/icons-material/FormatAlignCenter'
import FormatAlignLeft from '@mui/icons-material/FormatAlignLeft'
import FormatAlignRight from '@mui/icons-material/FormatAlignRight'

export const TextAlignGrid = ({ setting, onChange }) => {
    return (
        <RadioGroup
            orientation="horizontal"
            aria-label="Alignment"
            name="alignment"
            variant="outlined"
            sx={{ display: 'flex', justifyContent: 'space-between' }}
            value={setting}
            onChange={onChange}
        >
            {['left', 'center', 'right'].map((item) => (
                <Box
                    key={item}
                    sx={(theme) => ({
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexGrow: 1,
                        width: 48,
                        height: 35,
                        '&:not([data-first-child])': {
                            borderLeft: '1px solid',
                            borderColor: 'divider',
                        },
                        [`&[data-first-child] .${radioClasses.action}`]: {
                            borderTopLeftRadius: `calc(${theme.vars.radius.sm} - 1px)`,
                            borderBottomLeftRadius: `calc(${theme.vars.radius.sm} - 1px)`,
                        },
                        [`&[data-last-child] .${radioClasses.action}`]: {
                            borderTopRightRadius: `calc(${theme.vars.radius.sm} - 1px)`,
                            borderBottomRightRadius: `calc(${theme.vars.radius.sm} - 1px)`,
                        },
                    })}
                >
                    <Radio
                        value={item}
                        disableIcon
                        overlay
                        label={
                            {
                                left: <FormatAlignLeft />,
                                right: <FormatAlignRight />,
                                center: <FormatAlignCenter />,
                            }[item]
                        }
                        variant={setting === item ? 'solid' : 'plain'}
                        slotProps={{
                            input: { 'aria-label': item },
                            action: {
                                sx: { borderRadius: 0, transition: 'none' },
                            },
                            label: { sx: { lineHeight: 0 } },
                        }}
                    />
                </Box>
            ))}
        </RadioGroup>
    )
}
